import styled from 'styled-components';

export const PartnerFormContainer = styled.div`
    width: 25rem;
`;

export const FormContainer = styled.form``;
